import { TextField, Grid, FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FieldTemplateFormProps } from '.';
import AliasInput from 'components/AliasInput/AliasInput';

export function NumberFieldTemplate({
  formik,
  disabled,
  isRepeatingFieldsEnabled,
}: FieldTemplateFormProps) {
  const { t } = useTranslation();

  return (
    <form>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            disabled={disabled}
            sx={{ mt: 1 }}
            fullWidth
            label={`${t('forms.fieldAttributes.label')} *`}
            type="text"
            name="label"
            value={formik.values.label}
            onChange={formik.handleChange}
            error={formik.touched.label && Boolean(formik.errors.label)}
            InputLabelProps={{
              shrink: true,
            }}
            helperText={formik.touched.label && formik.errors.label}
          />
        </Grid>

        <Grid item xs={3} display={'flex'} alignItems={'center'}>
          <FormControlLabel
            disabled={disabled}
            control={<Checkbox />}
            label={`${t('forms.fieldAttributes.isRequired')}`}
            checked={formik.values.isRequired}
            onChange={() => {
              formik.setFieldValue('isRequired', !formik.values.isRequired);
            }}
          />
        </Grid>

        <Grid item xs={3} display={'flex'} alignItems={'center'}>
          {isRepeatingFieldsEnabled && (
            <FormControlLabel
              disabled={disabled}
              control={<Checkbox />}
              label={`${t('forms.fieldAttributes.isRepeatable')}`}
              checked={formik.values.isRepeatable}
              onChange={() => {
                formik.setFieldValue(
                  'isRepeatable',
                  !formik.values.isRepeatable,
                );
              }}
            />
          )}
        </Grid>

        <Grid item xs={6}>
          <AliasInput
            disabled={disabled}
            type="text"
            name="alias"
            value={formik.values.alias}
            onChange={formik.handleChange}
            fullWidth
            error={formik.touched.alias && Boolean(formik.errors.alias)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={6} mt={1}>
          <TextField
            disabled={disabled}
            label={t('forms.fieldAttributes.defaultValue')}
            type="number"
            name="defaultValue"
            value={formik.values.defaultValue}
            onChange={formik.handleChange}
            fullWidth
            error={
              formik.touched.defaultValue && Boolean(formik.errors.defaultValue)
            }
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled={disabled}
            sx={{ mt: 1 }}
            fullWidth
            label={t('forms.fieldAttributes.unit')}
            type="unit"
            name="unit"
            value={formik.values.unit}
            onChange={formik.handleChange}
            error={formik.touched.unit && Boolean(formik.errors.unit)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled={disabled}
            sx={{ mt: 1 }}
            fullWidth
            label={t('forms.fieldAttributes.minValue')}
            type="number"
            name="minValue"
            value={formik.values.minValue}
            onChange={formik.handleChange}
            error={formik.touched.minValue && Boolean(formik.errors.minValue)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled={disabled}
            sx={{ mt: 1 }}
            fullWidth
            label={t('forms.fieldAttributes.maxValue')}
            type="number"
            name="maxValue"
            value={formik.values.maxValue}
            onChange={formik.handleChange}
            error={formik.touched.maxValue && Boolean(formik.errors.maxValue)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            disabled={disabled}
            sx={{ mt: 1 }}
            fullWidth
            label={t('forms.fieldAttributes.description')}
            type="text"
            name="description"
            value={formik.values.description}
            onChange={formik.handleChange}
            multiline
            rows={3}
            error={
              formik.touched.description && Boolean(formik.errors.description)
            }
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      </Grid>
    </form>
  );
}
